
define('txt!modules/module.loader.hbs',[],function () { return '<div class="module-loader-wrap">\n  <div class="module-loader"></div>\n</div>\n';});

